<template>
    <li class="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200">
        <div class="grid grid-cols-3 gap-0">
            <!-- <div class="flex">
                <img class="w-full object-cover" :src="consultant.profile_photo_url" alt=""/>
            </div> -->
            <div class="col-span-3 flex flex-col divide-y divide-gray-200">
                <div class="flex-1 flex p-6 justify-center items-center">
                    <div>
                        <h3 class="text-primary-500 mb-4 text-lg font-bold">{{ consultant.name }}</h3>
                        <dl class="flex flex-col justify-between">
                            <dt class="sr-only">{{ $t('Function') }}</dt>
                            <dd class="text-secondary-500 text-sm mb-1">{{ consultant.departement }}</dd>
                            <dt class="sr-only">{{ $t('Company') }}</dt>
                            <dd class="text-gray-500 text-sm mb-1">{{ consultant.company }}</dd>
                            <template v-if="consultant.phone?.length > 0">
                                <dt class="sr-only">{{ $t('Phone') }}</dt>
                                <dd class="text-gray-500 text-sm">{{ consultant.phone }}</dd>
                            </template>
<!--                            <dt class="sr-only">Function</dt>
                            <dd class="mt-2">
                                <span class="px-2 py-1 text-primary-800 text-xs font-medium bg-primary-100 rounded-full">{{ consultant.departement }}</span>
                            </dd>-->
                        </dl>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="-mt-px flex divide-x divide-gray-200">
                <div class="w-0 flex-1 flex">
                    <a :href="`mailto:${consultant.email}`"
                       class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-primary-600">
                        <MailIcon class="w-5 h-5 text-gray-400" aria-hidden="true"/>
                        <span class="ml-3">{{ $t('Write email') }}</span>
                    </a>
                </div>
               <div class="-ml-px w-0 flex-1 flex" v-if="consultant.phone?.length > 0">
                                    <a :href="`tel:${consultant.phone}`" class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500">
                                        <PhoneIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                                        <span class="ml-3">{{ $t('Call') }}</span>
                                    </a>
                                </div>
            </div>
        </div>
    </li>
</template>

<script setup>
import {MailIcon, PhoneIcon} from '@heroicons/vue/solid'

</script>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: "ConsultantContainer",
    components: {},
    props: {
        consultant: Object,
    },
    computed: {},
    data() {
        return {};
    },
    methods: {},
});
</script>

<style scoped>

</style>
